
import { getModel } from '../js/date'

export default {
  data: () => ({
    current: '0',
    tabs: getModel(),
    tableLoading: false,
  }),

  computed: {
    pickerBind: () => ({
      type: 'daterange',
      rangeSeparator: '至',
      startPlaceholder: '开始日期',
      endPlaceholder: '结束日期',
      valueFormat: 'yyyy-MM-dd HH:mm:ss',
      defaultTime: [ '00:00:00', '23:59:59' ],
      clearable: false,
    }),

    tableParam: (vm) => {
      const item = vm.tabs[vm.current - 0]
      return {
        begin_time: item.date[0],
        end_time: item.date[1],
      }
    },
  },

  watch: {
    current: {
      // immediate: true,
      handler() {
        this.loadData()
      },
    },
  },

  methods: {
    // 在外界重写这个方法！！
    async loadData() {

    },
  },

  created() {
    this.tabs = getModel()
  },

}